export default "__VITE_ASSET__77c792e6__"